/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Scale3d = [
  "svg",
  defaultAttributes,
  [
    ["circle", { cx: "19", cy: "19", r: "2" }],
    ["circle", { cx: "5", cy: "5", r: "2" }],
    ["path", { d: "M5 7v12h12" }],
    ["path", { d: "m5 19 6-6" }]
  ]
];

export { Scale3d as default };
//# sourceMappingURL=scale-3d.js.map
